import * as pdfjs from 'pdfjs-dist';

pdfjs.GlobalWorkerOptions.workerPort = new Worker(new URL('pdfjs-dist/build/pdf.worker.js', import.meta.url));

export default pdfjs;
